/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import RangeInput from '../../../../common/RangeInput/RangeInput'

/**
 * Will return the changed value
 *
 * @param {any} props
 * @returns {number} the value to use
 */
const changeInput = (props) => {
    return (props.value / 2.5)
}

/**
 * Will generate the measurements lines in the layour
 *
 * @param {any} N
 * @returns {ReactDOM}
 */
const generateMeasurements = (N: number) => {
    let array = Array.apply(null, { length: N }).map(Number.call, Number)
    let i = 0
    let _width: any = document.getElementsByClassName('rangeslider__labels')
    let va = 28
    if (_width.length > 0) {
        _width = _width[0].clientWidth
        va = (_width + 40) / N
    }
    // 
    return array.map((item, index) => {
        if (i === 0) {
            i = 10
        } else {
            i += 28
        }
        return (
            <div
                className={`measurements measurements-commission-${item + 1}`}
                key={index}
                style={{ 'left': `${item === 0 ? '10px' : `${(i + 10)}px`}` }}
            />
        )
    })
}

const RateVariationCommission = (props: any) => (
    <div className="adjustment">
        <div className="adjustment__title">Commission:</div>
        <div className="adjustment__range">
            <div className="range_slides">
                <div>
                    {generateMeasurements(Math.round(props.maxCommission / 2.5) + 1)}
                </div>
            </div>
            <RangeInput
                onChange={(value) => { props.onChange(value * 2.5) }}
                value={changeInput(props)}
                max={Math.round(props.maxCommission / 2.5)}
                min={0}
            />
        </div>
        <div className="adjustment__result">{props.value}%</div>
    </div>
) // min 0% - 22.5% max

export default RateVariationCommission



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05m/components/RateVariationCommission.tsx